import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { ReactNode } from 'react';
import { FormLabel } from 'src/components/FormLabel';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { Tooltip } from 'src/components/Tooltip';
import { SxProps } from 'src/components/muiTheme/utils';

export const TooltipLabel = ({
  text,
  tooltip,
  required,
  sx,
}: {
  text: string | ReactNode;
  tooltip: string | ReactNode;
  required?: boolean;
  sx?: SxProps;
}) => {
  return (
    <Stack direction="row" alignItems="center" sx={{ mb: 1, gap: 0.5, ...sx }}>
      <FormLabel>
        {text}
        {required && ' *'}
      </FormLabel>
      <Tooltip title={tooltip}>
        <Icon
          size="small"
          icon={icon({ name: 'question-circle', style: 'regular' })}
        />
      </Tooltip>
    </Stack>
  );
};
